module.exports = __webpack_public_path__ + "img/title.5dbf783d.png";